export default "__VITE_ASSET__nnssB1rL__"